module.exports = __webpack_public_path__ + "img/B2B2C_shop.79020a2e.png";